//  servizio di mapping per label

const MapperService = {
  getPostEventDefaultMessage: function (actionCode) {
    switch (actionCode) {
      case 'PostSubscription_SubscriptionRequestCompleted':
        return 'Load.PostEventDefaultPage.PostSubscription_SubscriptionRequestCompletedDefaultMessage'
      case 'PostSubscription_SubscriptionCompleted':
        return 'Load.PostEventDefaultPage.PostSubscription_SubscriptionCompletedDefaultMessage'
      case 'PostSubscription_UnableToSendSubscriptionConfirmationRequestMessage':
        return 'Load.PostEventDefaultPage.PostSubscription_UnableToSendSubscriptionConfirmationRequestMessageDefaultMessage'
      case 'PostSubscription_RecipientAlreadySubscribed':
        return 'Load.PostEventDefaultPage.PostSubscription_RecipientAlreadySubscribedDefaultMessage'
      case 'PostSubscription_GenericError':
        return 'Load.PostEventDefaultPage.PostSubscription_GenericErrorDefaultMessage'
      case 'PostSubscription_RecipientDoesNotExist':
        return 'Load.PostEventDefaultPage.PostSubscription_RecipientDoesNotExistDefaultMessage'
      case 'PostSubscription_RecipientInactive':
        return 'Load.PostEventDefaultPage.PostSubscription_RecipientInactiveDefaultMessage'
      case 'PostUnsubscription_RecipientAlreadyUnsubscribed':
        return 'Load.PostEventDefaultPage.PostUnsubscription_RecipientAlreadyUnsubscribedDefaultMessage'
      case 'PostUnsubscription_UnsubscriptionCompleted':
        return 'Load.PostEventDefaultPage.PostUnsubscription_UnsubscriptionCompletedDefaultMessage'
      case 'PostUnsubscription_UpdateOK':
        return 'Load.PostEventDefaultPage.PostUnsubscription_UpdateOKDefaultMessage'
      case 'PostUnsubscription_RecipientDoesNotExist':
        return 'Load.PostEventDefaultPage.PostUnsubscription_RecipientDoesNotExistDefaultMessage'
      case 'PostUnsubscription_GenericError':
        return 'Load.PostEventDefaultPage.PostUnsubscription_GenericErrorDefaultMessage'
      case 'PostProfiling_ChangesSaved':
        return 'Load.PostEventDefaultPage.PostProfiling_ChangesSavedDefaultMessage'
      case 'PostProfiling_ConfirmSubscription':
        return 'Load.PostEventDefaultPage.PostProfiling_ConfirmSubscriptionDefaultMessage'
      case 'PostProfiling_Unsubscribed':
        return 'Load.PostEventDefaultPage.PostProfiling_UnsubscribedDefaultMessage'
      case 'PostProfiling_PrivateFormAccessEmailSent':
        return 'Load.PostEventDefaultPage.PostProfiling_PrivateFormAccessEmailSentDefaultMessage'
      case 'PostProfiling_RecipientDoesNotExist':
        return 'Load.PostEventDefaultPage.PostProfiling_RecipientDoesNotExistDefaultMessage'
      case 'PostProfiling_UpdateFailed':
        return 'Load.PostEventDefaultPage.PostProfiling_UpdateFailedDefaultMessage'
      case 'PostProfiling_FormNotActive':
        return 'Load.PostEventDefaultPage.PostProfiling_FormNotActiveDefaultMessage'
      case 'PostProfiling_FormAlreadyFilledOut':
        return 'Load.PostEventDefaultPage.PostProfiling_FormAlreadyFilledOutDefaultMessage'
      default:
        return ''
    }
  }

}

export default MapperService
